var _title, _desc, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconPaste = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "19E726B1-7BF6-41B2-8A40-24F1874B01E2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/copy/blue",
    fill: "#535878",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7885234,2 L4.97012673,2 C3.88340272,2.00299533 3.00324494,2.81544866 3,3.81857852 L3,16.5453554 L4.97012673,16.5453554 L4.97012673,3.81857852 L16.7885234,3.81857852 L16.7885234,2 Z M19.7431226,5.63606611 L8.90919835,5.63606611 C7.82247434,5.63906144 6.94231656,6.45151477 6.93907162,7.45464463 L6.93907162,20.1825124 C6.94296488,21.1852162 7.82293376,21.9970079 8.90919835,22 L19.7431226,22 C20.8298466,21.9970047 21.7100044,21.1845513 21.7132493,20.1814215 L21.7132493,7.45464463 C21.7100044,6.45151477 20.8298466,5.63906144 19.7431226,5.63606611 Z",
    id: "Path_421"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPaste, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-paste.cc7db632.svg";
export { ForwardRef as ReactComponent };